import { Component, Input, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatInput } from '@angular/material';


@Component({
  selector: 'app-shared-datepicker',
  templateUrl: './shared-datepicker.component.html'
})
export class SharedDatepickerComponent implements OnInit {
  @ViewChild("input2", { read: MatInput }) input2: MatInput;
  @Input() final: any;
  @Input() isEndDate: boolean = true;
  toDate: string;
  @Input() invaliddate: boolean = false;
  @Output() private toDateEvent = new EventEmitter<string>();
  @Output() private resetTo = new EventEmitter<any>();
  @Output() private isEmpty = new EventEmitter<any>();
  constructor() {
  }

  ngOnInit(): void {
  }

  reset_To() {
    this.input2.value = "";
    this.resetTo.emit(true);
  }

  is_empty() {
    this.isEmpty.emit(true);
  }

  toDate_event(event) {
    this.toDateEvent.emit(event);
  }

  @Input() set toDateflag(flag: boolean) {
    this.toDate = "";
  }
}
